module.exports = __webpack_public_path__ + "img/students.0582450e.svg";